import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const FullWidthBox = styled(Box)({
  width: '100%',
});
